import { DaylightCommonContent } from "../DaylightCommonContent/DaylightCommonContent";
import { DaylightMedia } from "../DaylightMedia/DaylightMedia";
import { HeroSurface } from "../HeroSurface/HeroSurface.client";
import type { IHeroSplitImageProps } from "./HeroSplitImage.props";

export const HeroSplitImage = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  headingEffect,
  image,
}: IHeroSplitImageProps) => (
  <div className="grid min-w-0 gap-4 md:min-h-[42rem] md:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]">
    <DaylightCommonContent
      alignment={alignment}
      buttons={buttons}
      className="daylight-hero-lines min-w-0 justify-end gap-5 md:py-6"
      description={description}
      eyebrow={eyebrow}
      heading={heading}
      headingEffect={headingEffect}
      headingAs="h1"
      headingClassName="max-w-[11ch] text-[clamp(2.5rem,5.6vw,4.25rem)] leading-[0.96] tracking-[-0.04em]"
      layout="stack"
    />
    {/* The surface takes its box from `data-hero-root`, so it is scoped to the
        image here rather than the whole split. `overflow-hidden` is left to the
        canvas's own radius: clipping the wrapper would cut the frame's ring. */}
    <div
      className="relative isolate h-full min-h-72 w-full min-w-0 md:order-last"
      data-hero-root=""
    >
      <div className="h-full w-full" data-hero-media="">
        <DaylightMedia
          aspectRatio={image.aspectRatio || "16:9"}
          className="h-full w-full"
          imageClassName="h-full object-cover"
          media={image.image}
          effect={image.effect}
          priority
          sizes="(min-width: 768px) 55vw, 100vw"
        />
      </div>
      <HeroSurface className="rounded-[14px]" saturation={1} voidBlend={1} />
    </div>
  </div>
);

HeroSplitImage.displayName = "Content::HeroSplitImage";
